const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213,185.8H86.36V99.16H213Zm-125.64-1H212V100.16H87.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.26,104.75a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,96.26,104.75Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,104.75a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,106.55,104.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.84,104.75a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,116.84,104.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.86,
    y: 109.18,
    width: 125.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.73,181.42l5.89-9.49-2.91-1.8a2.68,2.68,0,0,1-1.23-2.5,13.25,13.25,0,0,0,0-1.67,2.67,2.67,0,0,1,1.39-2.41l3-1.61-5.28-9.85-3,1.62a2.66,2.66,0,0,1-2.77-.18,15.13,15.13,0,0,0-1.42-.88,2.66,2.66,0,0,1-1.4-2.41l.11-3.42L647,146.47l-.1,3.43a2.66,2.66,0,0,1-1.56,2.31l-.73.37-.72.41a2.63,2.63,0,0,1-2.77,0l-2.93-1.81-5.88,9.49,2.91,1.81a2.65,2.65,0,0,1,1.23,2.5,15.26,15.26,0,0,0-.06,1.66,2.67,2.67,0,0,1-1.38,2.41l-3,1.61,5.28,9.85,3-1.62a2.66,2.66,0,0,1,2.77.18,14.87,14.87,0,0,0,1.41.87,2.67,2.67,0,0,1,1.41,2.41l-.11,3.43,11.16.34.11-3.42a2.66,2.66,0,0,1,1.55-2.31c.25-.11.5-.24.74-.37s.48-.26.72-.41a2.65,2.65,0,0,1,2.78,0Zm-9.45-7A9.15,9.15,0,1,1,660,162,9.14,9.14,0,0,1,656.28,174.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.82,266.12l5.88-9.49-2.9-1.8a2.66,2.66,0,0,1-1.24-2.5,15.44,15.44,0,0,0,.06-1.67,2.67,2.67,0,0,1,1.38-2.41l3-1.61-5.28-9.85-3,1.62a2.66,2.66,0,0,1-2.77-.18,16,16,0,0,0-1.42-.88,2.66,2.66,0,0,1-1.4-2.41l.11-3.42-11.16-.34L93,234.61a2.66,2.66,0,0,1-1.55,2.31c-.25.11-.5.24-.74.37s-.48.26-.71.41a2.69,2.69,0,0,1-2.78,0l-2.92-1.82-5.89,9.49,2.91,1.81a2.64,2.64,0,0,1,1.23,2.5,13.15,13.15,0,0,0,0,1.66,2.67,2.67,0,0,1-1.39,2.41l-3,1.62,5.28,9.84,3-1.61a2.64,2.64,0,0,1,2.77.17,16,16,0,0,0,1.42.88,2.66,2.66,0,0,1,1.4,2.41l-.11,3.42,11.17.35.1-3.43a2.65,2.65,0,0,1,1.56-2.3c.24-.12.49-.24.74-.38s.48-.26.71-.4a2.67,2.67,0,0,1,2.79,0Zm-9.45-7.05a9.15,9.15,0,1,1,3.74-12.38A9.14,9.14,0,0,1,102.37,259.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.72,109.36l-3.91-6.77-2.07,1.2a1.87,1.87,0,0,1-2-.07c-.33-.21-.66-.41-1-.59a1.84,1.84,0,0,1-1-1.65V99.09h-7.83v2.39a1.84,1.84,0,0,1-1,1.65,11.12,11.12,0,0,0-1,.59,1.87,1.87,0,0,1-2,.07l-2.08-1.2-3.91,6.77,2.09,1.2a1.89,1.89,0,0,1,.91,1.73c0,.19,0,.38,0,.58s0,.38,0,.57a1.87,1.87,0,0,1-.91,1.72l-2.09,1.21,3.91,6.77,2.08-1.19a1.85,1.85,0,0,1,2,.06,11.53,11.53,0,0,0,1,.59,1.85,1.85,0,0,1,1,1.65v2.4h7.83v-2.4a1.86,1.86,0,0,1,1-1.65,9.19,9.19,0,0,0,1-.59,1.85,1.85,0,0,1,2-.06l2.08,1.19,3.91-6.77-2.08-1.2a1.84,1.84,0,0,1-.9-1.72c0-.2,0-.39,0-.58s0-.39,0-.58a1.87,1.87,0,0,1,.91-1.73Zm-7.48,3.51a6.41,6.41,0,1,1-6.4-6.42A6.39,6.39,0,0,1,618.24,112.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63,75.3,95.75,75l6.66-.11c2.23,0,4.47,0,6.7-.06h.44v.45l.06,11.19V87h-.5l-13.24-.06c-4.42,0-8.83-.12-13.24-.17h-.28v-.27c0-1.9.08-3.79.13-5.65Zm0,0L82.77,81c0,1.87.11,3.71.13,5.54l-.27-.27c4.41,0,8.82-.16,13.24-.17L109.11,86l-.5.5,0-11.19.45.45c-2.18,0-4.36,0-6.55-.06L96,75.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4,61.19l13.12-.28,6.67-.11c2.22,0,4.46,0,6.69-.06h.44v.45l0,11.19v.5h-.5l-13.24-.06c-4.41,0-8.83-.12-13.24-.17h-.28v-.27c0-1.9.08-3.79.13-5.65Zm0,0,.14,5.65c0,1.87.11,3.71.13,5.54l-.27-.27c4.41,0,8.83-.16,13.24-.17l13.24-.06-.5.5.05-11.19.45.45c-2.18,0-4.36,0-6.55-.06l-6.57-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.86,61.19,81,60.91l6.66-.11c2.23,0,4.47,0,6.7-.06h.44v.45l.06,11.19v.5h-.5L81.1,72.82c-4.42,0-8.83-.12-13.24-.17h-.28v-.27c0-1.9.09-3.79.13-5.65Zm0,0L68,66.84c0,1.87.11,3.71.13,5.54l-.27-.27c4.41,0,8.82-.16,13.24-.17l13.24-.06-.5.5,0-11.19.45.45c-2.19,0-4.36,0-6.55-.06l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.21,208.46l13.12-.28,6.66-.11c2.23,0,4.47,0,6.7-.06h.44v.45l.06,11.19v.5h-.5l-13.24-.07c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.79.14-5.66Zm0,0,.14,5.65c0,1.86.11,3.71.13,5.54l-.27-.28c4.41-.05,8.82-.15,13.24-.16l13.24-.06-.5.5.05-11.19.45.44c-2.18,0-4.36,0-6.55-.05l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475,194.35l13.12-.28,6.67-.11c2.22-.05,4.46,0,6.69-.06h.44v.45l0,11.19v.5h-.5L488.22,206c-4.41,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.08-3.79.13-5.66Zm0,0,.14,5.65c.05,1.86.11,3.71.13,5.54l-.27-.28c4.41,0,8.83-.15,13.24-.16l13.24-.06-.5.5.05-11.19.45.44c-2.18,0-4.36,0-6.55,0l-6.57-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.44,194.35l13.12-.28,6.66-.11c2.23-.05,4.46,0,6.7-.06h.44v.45l.06,11.19v.5h-.5L458.68,206c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.79.13-5.66Zm0,0,.14,5.65c0,1.86.11,3.71.13,5.54l-.27-.28c4.41,0,8.82-.15,13.24-.16l13.24-.06-.5.5.05-11.19.45.44c-2.19,0-4.36,0-6.55,0l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.62,71.37l13.13-.28,6.66-.11c2.22,0,4.46,0,6.69,0h.44v.45l.05,11.19v.5h-.5L656.86,83c-4.41,0-8.83-.12-13.24-.17h-.27v-.27c0-1.9.08-3.79.13-5.65Zm0,0,.14,5.65c0,1.87.12,3.71.13,5.54l-.27-.27c4.41-.05,8.83-.16,13.24-.17l13.24-.06-.5.5.06-11.19.44.45c-2.18,0-4.36,0-6.54-.06L657,71.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.14,208.46l13.12-.27,6.66-.12c2.23,0,4.47,0,6.7,0h.44v.44l.06,11.19v.51h-.5l-13.24-.06c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.89.08-3.78.13-5.65Zm0,0,.14,5.66c.05,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.82-.16,13.24-.16l13.24-.06-.5.49.05-11.19.45.45c-2.18,0-4.36,0-6.55,0l-6.58-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,317.14l13.12-.27,6.67-.12c2.22,0,4.46,0,6.69-.05h.44v.44l0,11.19v.51h-.5l-13.24-.06c-4.41,0-8.83-.11-13.24-.16h-.28v-.27c0-1.89.08-3.78.13-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41-.05,8.83-.16,13.24-.16l13.24-.07-.5.5,0-11.19.45.45c-2.18,0-4.36,0-6.55,0l-6.57-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.39,303l13.12-.27,6.66-.12c2.23,0,4.47,0,6.7-.05h.44V303l.06,11.19v.51h-.5l-13.24-.06c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.89.09-3.78.14-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41-.05,8.82-.16,13.24-.16l13.24-.07-.5.5,0-11.19.45.45c-2.18,0-4.36,0-6.55-.05l-6.58-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.66,317.13l13.13-.28,6.66-.11c2.22-.05,4.46,0,6.69-.05h.45v.45l0,11.19v.5h-.51l-13.24-.06c-4.41,0-8.82-.11-13.24-.16h-.27v-.27c0-1.9.09-3.78.13-5.65Zm0,0,.15,5.66c0,1.86.11,3.7.13,5.53l-.28-.27c4.42-.05,8.83-.16,13.24-.16l13.24-.07-.5.5.06-11.19.44.45c-2.18,0-4.35,0-6.54-.06l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.15 404.94 128.36 404.7 210.57 404.61 375 404.44 539.42 404.61 621.64 404.7 703.85 404.94 621.64 405.19 539.42 405.27 375 405.44 210.57 405.27 128.36 405.19 46.15 404.94",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-73"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.86,
    cy: 452.86,
    rx: 301.98,
    ry: 15.44,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.01,
    y: 432.67,
    width: 189.97,
    height: 15.87,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.36 432.68 302.63 432.68 306.31 405.13 306.49 403.83 306.83 401.24 307 399.94 307.36 397.36 307.4 396.96 307.52 396.06 307.88 393.47 308.05 392.18 310.62 372.93 439.38 372.93 441.81 391.08 441.93 391.96 442.33 394.97 442.44 395.84 442.59 396.96 442.85 398.85 442.96 399.73 443.36 402.75 443.48 403.61 447.36 432.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.59 396.96 308.05 392.18 310.62 372.93 439.38 372.93 442.59 396.96",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.27,
    y: 51.46,
    width: 487.45,
    height: 331.46,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.27,
    y: 334.02,
    width: 487.45,
    height: 48.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.93,355.18a8.08,8.08,0,1,1-8.07-8.07A8.07,8.07,0,0,1,382.93,355.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 73.01,
    width: 442.46,
    height: 238.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 73.01,
    width: 442.46,
    height: 238.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 83.78,
    width: 434.62,
    height: 30.78,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.38,
    y: 94.07,
    width: 10.5,
    height: 1.69,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.38,
    y: 101.63,
    width: 10.5,
    height: 1.69,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.38,
    y: 97.9,
    width: 10.5,
    height: 1.69,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.19,
    y: 94.16,
    width: 238.3,
    height: 9.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.58,103.32H200.1V94.07H438.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.33,
    y: 94.07,
    width: 9.25,
    height: 9.25,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.83,101.24l-.84.63-1.55-2.05-.56-.75a1.14,1.14,0,0,0,.32-.18,1.3,1.3,0,0,0,.43-.56l.6.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.18,96.41a2.29,2.29,0,1,0-.74,3.41,2.14,2.14,0,0,0,.32-.2,2.41,2.41,0,0,0,.47-.49A2.28,2.28,0,0,0,435.18,96.41Zm-1,2.48a1.14,1.14,0,0,1-.32.18,1.36,1.36,0,1,1,.57-2.1,1.38,1.38,0,0,1,.18,1.36A1.3,1.3,0,0,1,434.2,98.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.09,
    y: 95.94,
    width: 0.49,
    height: 5.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.46,103.58a4.88,4.88,0,0,1-1.48.62,5.15,5.15,0,1,1,1.48-.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.32,98.61A1.57,1.57,0,1,1,569.76,97,1.56,1.56,0,0,1,571.32,98.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.46,102.93v.65a4.88,4.88,0,0,1-1.48.62,5.13,5.13,0,0,1-3.93-.62v-.65a2.71,2.71,0,1,1,5.41,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.63,104.35h-3.58v-1.27a.18.18,0,0,0-.11-.17,4,4,0,0,1-.39-.23.2.2,0,0,0-.2,0l-1.1.64-1.79-3.1,1.1-.64a.19.19,0,0,0,.09-.18c0-.07,0-.14,0-.22s0-.15,0-.22a.19.19,0,0,0-.09-.18l-1.1-.64,1.79-3.1,1.1.64a.2.2,0,0,0,.2,0l.39-.23a.18.18,0,0,0,.11-.17V94h3.58v1.27a.18.18,0,0,0,.11.17l.39.23a.2.2,0,0,0,.2,0l1.1-.64,1.79,3.1-1.1.64A.17.17,0,0,0,557,99v.44a.17.17,0,0,0,.09.18l1.1.64-1.79,3.1-1.1-.63a.18.18,0,0,0-.2,0,4,4,0,0,1-.39.23.18.18,0,0,0-.11.17Zm-2.69-.89h1.8v-.38a1.05,1.05,0,0,1,.59-1l.31-.18a1.09,1.09,0,0,1,1.14,0l.32.19.9-1.55-.33-.2a1,1,0,0,1-.53-1V99a1.08,1.08,0,0,1,.53-1l.33-.19-.9-1.55-.32.19a1.09,1.09,0,0,1-1.14,0,3.07,3.07,0,0,0-.31-.17,1.08,1.08,0,0,1-.59-1v-.38h-1.8v.38a1.1,1.1,0,0,1-.59,1,3.07,3.07,0,0,0-.31.17,1.09,1.09,0,0,1-1.14,0l-.32-.19-.9,1.55L549,98a1.09,1.09,0,0,1,.54,1v.35a1.08,1.08,0,0,1-.53,1l-.33.19.9,1.55.32-.19a1.09,1.09,0,0,1,1.14,0l.3.18a1.06,1.06,0,0,1,.6,1Zm.9-1.64a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,552.84,101.82Zm0-4.41a1.76,1.76,0,1,0,1.75,1.76A1.76,1.76,0,0,0,552.84,97.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 73.01,
    width: 442.46,
    height: 10.77,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.33,78.4a2.67,2.67,0,1,1-2.67-2.68A2.68,2.68,0,0,1,162.33,78.4Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.24,78.4a2.68,2.68,0,1,1-2.67-2.68A2.68,2.68,0,0,1,173.24,78.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,78.4a2.67,2.67,0,1,1-2.67-2.68A2.67,2.67,0,0,1,184.14,78.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.38,
    y: 83.78,
    width: 7.85,
    height: 227.25,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.3,177.09h0a2,2,0,0,1-2-2V87.38a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2v87.68A2,2,0,0,1,592.3,177.09Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.32,98.61A1.57,1.57,0,1,1,569.76,97,1.56,1.56,0,0,1,571.32,98.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.46,102.93v.65a4.88,4.88,0,0,1-1.48.62,5.13,5.13,0,0,1-3.93-.62v-.65a2.71,2.71,0,1,1,5.41,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.41,
    y: 156.4,
    width: 94.14,
    height: 94.14,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.24,195.24a17.77,17.77,0,1,1-17.76-17.77A17.76,17.76,0,0,1,517.24,195.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.17,244.23v6.32H468.79v-6.32a30.69,30.69,0,1,1,61.38,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538.83,
    cy: 237.86,
    r: 18.16,
    transform: "translate(-10.37 450.68) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.89,
    y: 227.78,
    width: 3.9,
    height: 20.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.89,
    y: 227.78,
    width: 3.9,
    height: 20.16,
    transform: "translate(300.98 776.69) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(233.08 269.92)",
    style: {
      fontSize: 10,
      fill: "#455a64",
      fontFamily: "Raleway-Bold, Raleway",
      fontWeight: 700
    }
  }, "USER 1"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(357.52 269.92)",
    style: {
      fontSize: 10,
      fill: "#407BFF",
      fontFamily: "Raleway-Bold, Raleway",
      fontWeight: 700
    }
  }, "USER 2"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(474.61 269.92)",
    style: {
      fontSize: 10,
      fill: "#a6a6a6",
      fontFamily: "Raleway-Bold, Raleway",
      fontWeight: 700
    }
  }, "ADD USER")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631,205.3c-1.73,9-2.29,20.09-8.09,27.62-4.55,5.89-11.84,8.84-19,10.15-15.67,2.88-35.7-1.07-42.26-17.51-2.61-6.57-.48-18.43,7.12-21.14,3.9-1.38,8-.93,12.1-1a16.71,16.71,0,0,0,13.11-6.22c6.74-8,7.44-14.94,10.67-24.6a7.24,7.24,0,0,1,3.65-4.61,19.22,19.22,0,0,1,12.88-1.4c4.26,1.51,7.49,6.55,10.27,9.87s3.75,6.4,3,10.76C633.44,193.23,632.19,199.26,631,205.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.13,209.76c1.06-8.35,2-16.71,2.89-25.07,0-.05-.07-.07-.07,0-1,6.86-2.06,13.69-3,20.56s-1.3,13.72-2.76,20.36c-3.28,14.89-20,17.27-32.4,13.52-.57-.17-.77.75-.2.9,11,3,25.16,2.34,31.4-8.91C630.45,225,630.26,216.58,631.13,209.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.63,171.94a.13.13,0,0,0-.25-.06c-2.33,8.07-4.28,17.69-10.63,23.68a21.28,21.28,0,0,1-11.32,5.54c-3.35.51-6.63-.16-10-.3-13.11-.54-17.28,16.33-9.77,25.11.16.18.49-.08.33-.28-5.17-6.63-5.06-16.41,1.79-22,5.5-4.46,13.13-.8,19.55-2.38C598.66,198,603,183.84,605.63,171.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621,205.6c14.4,16,26.47,34.39,24.73,40.74-2.34,8.54-16.4,24-24.44,31.38-2.36,2.17-18.83-16.56-16.3-18.88,3-2.8,19.06-17,19.26-17.38.45-.77-7.15-24.31-9.11-29.89C611.86,202.25,614.6,198.51,621,205.6Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.64,288.15c4.9-2.08,13.25-10.27,14.51-13S611,257.71,607.86,258s-19.05,8.56-21.62,13.35S603.56,290.32,608.64,288.15Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.67,264.75c2.8.4.73,3.46.73,3.46s4-3.69,6.76-2.17,0,5.09-.19,5.35c.21-.19,4-3.49,6.59-1.67s-.58,5.06-.79,5.26c.26-.12,3.73-1.63,5.38.19,2.83,3.14-5.95,7.25-7,10.51,0,0,5.33,2.37,5.47,2.47s-8.28,4.09-12.6,2.46a3,3,0,0,1-1.92-3.15s-2.52,1.62-4.6.25c-1.06-.7-.88-3-.88-3a3.7,3.7,0,0,1-3.85-.12c-1.41-1.05-1-3.22-1-3.22s-2.53.23-3.63-1.31C577.93,276.91,585.69,263.9,591.67,264.75Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.79,281s-.09,0-.08,0A26.25,26.25,0,0,1,592.49,268c.14-.11.36.07.23.21A53.84,53.84,0,0,0,583.79,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.57,284.73c0,.06-.11,0-.09-.05a24.59,24.59,0,0,1,10.45-13.5c.18-.1.44,0,.25.12C595.89,273.56,590.71,280.33,588.57,284.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.2,274.9c-4.84,3.08-8.21,7.41-11,12.35,0,.07-.12,0-.11-.06.72-2.79,2.85-5.75,4.7-7.92a15.08,15.08,0,0,1,6.33-4.54C605.19,274.69,605.31,274.83,605.2,274.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.4,268.21a18.16,18.16,0,0,1,2.68-1.67,5.78,5.78,0,0,1,2.93-.72,1.9,1.9,0,0,1,1.23.58,2.93,2.93,0,0,1,.66,1.24,3.37,3.37,0,0,1-.72,2.65l-1.38,1.86,1.94-1.26a9.8,9.8,0,0,1,2.8-1.26,3.43,3.43,0,0,1,2.76.3,1.94,1.94,0,0,1,.83,2.29,5.7,5.7,0,0,1-1.66,2.41l-2,1.87,2.5-1.1a9.13,9.13,0,0,1,2.18-.65,3.59,3.59,0,0,1,2.1.2,1.72,1.72,0,0,1,1,1.53,3.82,3.82,0,0,1-.84,2,29.43,29.43,0,0,1-3.23,3.49c-.57.57-1.14,1.14-1.68,1.73a5.82,5.82,0,0,0-1.34,2,6.16,6.16,0,0,1,1.49-1.84c.59-.55,1.2-1.07,1.81-1.59a25.88,25.88,0,0,0,3.48-3.39,4.49,4.49,0,0,0,1.08-2.35,2.46,2.46,0,0,0-1.41-2.32,4.56,4.56,0,0,0-2.61-.31,9.37,9.37,0,0,0-2.43.69l.49.76a6.69,6.69,0,0,0,2-2.83,2.82,2.82,0,0,0,0-1.9,3.17,3.17,0,0,0-1.21-1.44,4.29,4.29,0,0,0-3.48-.38,10.32,10.32,0,0,0-3.06,1.43l.56.59a4,4,0,0,0,.71-3.32,3.35,3.35,0,0,0-.89-1.49,2.45,2.45,0,0,0-1.6-.67,5.9,5.9,0,0,0-3.1,1A14.14,14.14,0,0,0,592.4,268.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.89,258.9s-22.6,0-18.29,8.8c1.28,2.63,9.68,11.89,11.57,10.24,2.45-2.13-.34-6.65-2.53-9.21,0,0,7.68,1.1,10-4A5.6,5.6,0,0,0,604.89,258.9Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.29,266.94a11.61,11.61,0,0,0,1.6,3.06,25.22,25.22,0,0,0,2.14,2.71,39.87,39.87,0,0,0,5,4.79,6.65,6.65,0,0,0,1.59.93,2.31,2.31,0,0,0,1,.17,1.82,1.82,0,0,0,.57-.12,1.89,1.89,0,0,0,.48-.31,2.92,2.92,0,0,0,.94-1.79,5.6,5.6,0,0,0-.12-1.88,10.43,10.43,0,0,0-1.47-3.25,24.26,24.26,0,0,0-2.12-2.78l-.37.65a13.83,13.83,0,0,0,2.65,0,13.26,13.26,0,0,0,2.59-.46,9.24,9.24,0,0,0,2.38-1.11,6.68,6.68,0,0,0,1.86-1.81,7.55,7.55,0,0,1-2,1.57,9.47,9.47,0,0,1-2.37.86,13.32,13.32,0,0,1-5,.13l-1-.17.64.83a24.78,24.78,0,0,1,1.95,2.74,10.26,10.26,0,0,1,1.32,3,2.83,2.83,0,0,1-.51,2.73c-.54.56-1.65-.05-2.51-.67s-1.76-1.4-2.62-2.15-1.69-1.52-2.49-2.32A21.52,21.52,0,0,1,586.29,266.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.34,214.07c-3.82-14,2.94-16.53,11.81-7a223.85,223.85,0,0,1,16,19.72l-21.39,9.82S615.79,223.05,613.34,214.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.17,201.47a.31.31,0,0,1-.19.06.33.33,0,0,1-.31-.2Zm-.19,8.3a.35.35,0,1,0,.35.35A.35.35,0,0,0,617,209.77Zm6.14,0a.35.35,0,1,0,.35.35A.35.35,0,0,0,623.12,209.77Zm-9.21-4.47a.36.36,0,1,0,.35.35A.35.35,0,0,0,613.91,205.3Zm6.14,0a.36.36,0,1,0,.35.35A.35.35,0,0,0,620.05,205.3ZM617,218.71a.35.35,0,0,0-.35.35.35.35,0,0,0,.7,0A.35.35,0,0,0,617,218.71Zm12.28,0a.35.35,0,0,0-.35.35.35.35,0,0,0,.35.35.34.34,0,0,0,.35-.35A.35.35,0,0,0,629.26,218.71Zm6.32.64a.28.28,0,0,1-.18.06.35.35,0,0,1-.35-.35.39.39,0,0,1,.1-.25Zm-12.46-.64a.35.35,0,0,0-.35.35.35.35,0,0,0,.7,0A.35.35,0,0,0,623.12,218.71Zm-9.21-4.46a.35.35,0,0,0-.35.35.35.35,0,0,0,.7,0A.35.35,0,0,0,613.91,214.25Zm12.28,0a.35.35,0,0,0-.35.35.35.35,0,0,0,.35.35.35.35,0,0,0,.35-.35A.34.34,0,0,0,626.19,214.25Zm-6.14,0a.35.35,0,0,0-.35.35.35.35,0,0,0,.7,0A.35.35,0,0,0,620.05,214.25Zm-2.85,13.48c0,.13.07.25.11.37a.3.3,0,0,0,0-.1A.35.35,0,0,0,617.2,227.73Zm5.92-.07a.35.35,0,0,0-.35.35.35.35,0,0,0,.7,0A.35.35,0,0,0,623.12,227.66Zm6.14,0a.35.35,0,0,0-.35.35.35.35,0,0,0,.35.35.35.35,0,0,0,.35-.35A.34.34,0,0,0,629.26,227.66Zm6.14,0a.35.35,0,0,0-.35.35.35.35,0,0,0,.35.35.35.35,0,0,0,.35-.35A.34.34,0,0,0,635.4,227.66Zm-15.35-4.47a.35.35,0,0,0-.35.35.35.35,0,0,0,.7,0A.35.35,0,0,0,620.05,223.19Zm6.14,0a.35.35,0,0,0-.35.35.35.35,0,0,0,.35.35.34.34,0,0,0,.35-.35A.35.35,0,0,0,626.19,223.19Zm6.14,0a.35.35,0,0,0-.35.35.35.35,0,0,0,.35.35.34.34,0,0,0,.35-.35A.35.35,0,0,0,632.33,223.19Zm6.22,0a.12.12,0,0,0-.08,0,.35.35,0,1,0,0,.7.34.34,0,0,0,.34-.32s0,0,0,0Zm-18.5,8.92a.36.36,0,1,0,.35.36A.36.36,0,0,0,620.05,232.13Zm6.14,0a.36.36,0,0,0,0,.71.36.36,0,0,0,0-.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.23,224.77c-3.15,1.21-15.89,6.65-18.56,8-.19.1-.17.24,0,.16a185.25,185.25,0,0,0,18.57-8.05A.06.06,0,1,0,638.23,224.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640,227.3l-20.22,9.28s-4-13.53-6.44-22.51c-2.92-10.69.31-14.68,5.94-11.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.53,463c1.88.63,55.63.47,57.68-.83.77-.48,1.21-8.32,1.46-17.79.06-2,.1-4.16.14-6.31,0-2.54.07-5.12.09-7.62.06-11.22-.09-21.11-.09-21.11h-35l0,21.11V438l.18,6.31s-20.55,9.26-22.64,10.93S555.65,462.35,557.53,463Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.53,463c1.88.63,55.63.47,57.68-.83.77-.48,1.21-8.32,1.46-17.79.06-2,.1-4.16.14-6.31,0-2.54.07-5.12.09-7.62H581.83V438l.18,6.31s-20.55,9.26-22.64,10.93S555.65,462.35,557.53,463Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.37,463c1.22.41,24.12.49,40.79.14,3.85-.08,7.38-.19,10.23-.31,3.92-.18,6.55-.39,7-.66.94-.61,1.4-12.11,1.61-24.24H581.81l.19,6.34s-20.67,9.32-22.78,11S555.48,462.41,557.37,463Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.14,460.88c9.06-.25,45.62-.4,54.6.05.07,0,.07.05,0,.05-9,.45-45.54.3-54.6,0C557.94,461,557.94,460.89,558.14,460.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.71,442.3c3.56-.67,7.93-.14,10.66,2.39.1.1,0,.25-.15.21a50.63,50.63,0,0,0-10.49-2.15A.23.23,0,0,1,580.71,442.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.14,443.86c3.56-.68,7.93-.14,10.66,2.39.1.1,0,.25-.15.21a50,50,0,0,0-10.49-2.15A.23.23,0,0,1,578.14,443.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.57,445.42c3.57-.68,7.93-.14,10.66,2.39.11.1,0,.25-.15.21a50,50,0,0,0-10.49-2.15A.23.23,0,0,1,575.57,445.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573,447c3.57-.68,7.93-.14,10.66,2.39.11.1,0,.25-.15.21A50,50,0,0,0,573,447.43.23.23,0,0,1,573,447Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.71,439.15c2.53,2,5.82,2.74,8.76,3.83a.45.45,0,0,0,.56-.45.09.09,0,0,0,.08-.13,18.88,18.88,0,0,0-5.51-8.15c-1.49-1.25-4.1-2.11-5.5-.17S574.24,438,575.71,439.15Zm-.91-2.87c-.64-3.91,3.56-1.87,4.63-.9a21.32,21.32,0,0,1,1.89,2c1.24,1.48,2.25,3.11,3.33,4.69-1.42-.62-2.87-1.11-4.31-1.68C578.63,439.75,575.15,438.44,574.8,436.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597,436.93c-.87-2.22-3.61-2-5.37-1.2a19.06,19.06,0,0,0-7.37,6.51.1.1,0,0,0,0,.15.44.44,0,0,0,.43.57c3.12-.31,6.5-.26,9.43-1.52C595.89,440.71,597.82,439,597,436.93Zm-7.62,4.59c-1.54.19-3.07.31-4.59.55,1.44-1.26,2.82-2.59,4.39-3.71a20.24,20.24,0,0,1,2.34-1.5c1.27-.66,5.85-1.59,4.26,2C594.9,440.9,591.2,441.29,589.38,441.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.48,260.18S619,353.72,618.8,354.9c0,.16-.1,2-.19,4.9-.51,16.1-1.77,66.31-1.77,66.31H578.25s2.52-59.47,4-73.35c1.84-17.69,13.45-92.58,13.45-92.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.2,358.2q1.78-30.4,5.36-60.66c1.36-11.36,3-22.69,4.61-34,0-.09.17-.09.15,0-3,20.16-5.1,40.48-6.92,60.78s-3.09,40.59-3.92,60.93c-.47,11.52-.83,23.05-1.2,34.58a.22.22,0,0,1-.43,0C612.4,399.27,613,378.72,614.2,358.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.69,419.89c1-.14,2.11-.09,3.13-.13l3.48-.09c2.23-.09,4.47-.14,6.7-.18,4.51-.07,9-.05,13.52.09l3.72.14c1.32,0,2.65.17,4,.16.1,0,.09.12,0,.12-2.26,0-4.56.19-6.83.28s-4.47.12-6.7.15c-4.51.06-9,0-13.52-.15l-3.72-.1-2-.08a17.45,17.45,0,0,1-1.77-.06C580.58,420,580.59,419.9,580.69,419.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.48,260.18S619,353.72,618.8,354.9c0,.16-.1,2-.19,4.9l-18.19-99.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.68,461.3c2-.21,50.87-22.53,52.2-24.56.5-.77-2.34-8.08-6-16.81-.79-1.89-1.54-3.88-2.48-5.8-1.18-2.43-2.39-4.84-3.59-7.15-5.16-10.05-9.9-18.28-9.9-18.28l-31,14L665.87,421l3.67,7.51,2.76,5.67s-14.9,16.92-16.11,19.3S655.72,461.51,657.68,461.3Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.68,461.3c2-.21,50.87-22.53,52.2-24.56.5-.77-2.34-8.08-6-16.81-.79-1.89-1.54-3.88-2.48-5.8-1.18-2.43-2.39-4.84-3.59-7.15-9.56,4.28-23.35,10.32-31.93,14.06l3.67,7.51,2.76,5.67s-14.9,16.92-16.11,19.3S655.72,461.51,657.68,461.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.56,461.43c2-.21,51.15-22.65,52.49-24.69.62-.94-3.72-11.6-8.53-22.74l-32,14.51,2.78,5.7s-15,17-16.21,19.41S655.58,461.64,657.56,461.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.37,459.14c8.15-4,41.4-19.18,49.75-22.48.07,0,.09,0,0,0-8,4.11-41.36,19.06-49.72,22.57C657.25,459.35,657.2,459.23,657.37,459.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.27,432.91c3-2.09,7.16-3.4,10.69-2.22.14,0,.07.24-.05.25a50.6,50.6,0,0,0-10.44,2.37A.23.23,0,0,1,670.27,432.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.57,435.39c3-2.09,7.16-3.4,10.7-2.22.13,0,.07.24,0,.25a50.06,50.06,0,0,0-10.45,2.37A.23.23,0,0,1,668.57,435.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.87,437.87c3-2.09,7.17-3.4,10.7-2.22.14,0,.07.24-.05.25a50.06,50.06,0,0,0-10.45,2.37A.23.23,0,0,1,666.87,437.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.18,440.35c3-2.09,7.16-3.4,10.69-2.22.14,0,.07.24,0,.25a50,50,0,0,0-10.44,2.37A.23.23,0,0,1,665.18,440.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.42,432.1c3.1.73,6.42.1,9.55-.13a.45.45,0,0,0,.33-.64.09.09,0,0,0,0-.15,19,19,0,0,0-8.38-5.15c-1.88-.52-4.61-.23-5.09,2.11S662.6,431.67,664.42,432.1Zm-2-2.24c-2.2-3.29,2.48-3.17,3.84-2.73a19.9,19.9,0,0,1,2.57,1.07,56.86,56.86,0,0,1,5,2.9c-1.54,0-3.07.17-4.61.25C667.32,431.44,663.61,431.68,662.4,429.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.89,421.29c-1.7-1.66-4.13-.36-5.38,1.12a19,19,0,0,0-4,9,.09.09,0,0,0,.1.11.45.45,0,0,0,.63.35c2.72-1.58,5.82-2.92,8-5.28C683.44,425.19,684.51,422.87,682.89,421.29Zm-5,7.33c-1.32.81-2.67,1.54-4,2.4a54.77,54.77,0,0,1,2.47-5.19,21.22,21.22,0,0,1,1.51-2.34c.88-1.13,4.68-3.86,4.72.1C682.61,425.77,679.41,427.66,677.84,428.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.67,260.18s2.54,13.51,12,20.39c0,0,20.78,69.55,23.49,77.53,4.65,13.74,29.67,60.3,29.67,60.3l38.61-16.58S670,350,666.78,346c-2.12-2.65-18-59-17.78-60.49,2.32-17.28-5.88-25.37-5.88-25.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.91,265.08a12.94,12.94,0,0,0,4.72,6.78,16,16,0,0,0,8.58,2.94.42.42,0,0,1,0,.83c-6.29,0-12.65-4-13.57-10.51C626.63,265,626.87,264.94,626.91,265.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.6,276.28a35.49,35.49,0,0,1,6.5,3.45c2.16,1.34,4.16,2.91,6.24,4.35.08.06,0,.19-.07.14-2.19-1.26-4.47-2.35-6.63-3.65a42.31,42.31,0,0,1-6.13-4.11C601.44,276.39,601.51,276.25,601.6,276.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.72,263.17c.34,1.44.75,2.86,1.13,4.29s.64,2.72,1.06,4a6.92,6.92,0,0,0,2.05,3.33c.56.47,1.16.88,1.75,1.31.32.23.66.45,1,.68-.05-.19-.09-.38-.14-.58l-.36-1.64c-.26-1.21-.51-2.43-.75-3.65-.48-2.39-.93-4.82-1.54-7.18a.07.07,0,1,1,.14,0c.71,2.33,1.48,4.64,2.12,7,.31,1.16,1.48,6.89,1.54,7.3s.12.84.15,1.26a4.75,4.75,0,0,1,.06,1.3c0,.11-.14.1-.19,0h0a5.18,5.18,0,0,1-.42-1.24c-.13-.4-.24-.82-.33-1.23,0-.15-.06-.31-.09-.46-.59-.32-1.14-.76-1.69-1.12s-1.19-.76-1.76-1.19a6.61,6.61,0,0,1-2.22-3.15,24.16,24.16,0,0,1-.87-4.12c-.26-1.64-.47-3.28-.77-4.91C600.55,263.12,600.7,263.07,600.72,263.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.69,410.6c.87-.52,10-4.78,12-5.71,4.09-1.88,18.24-7.67,19.57-8.16.44-.16.47.08.13.24-2.09,1-10.28,4.77-12.31,5.7-4.1,1.87-18.81,7.91-19.37,8.08A.08.08,0,0,1,660.69,410.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.62,261.77A32,32,0,0,1,646,279a28,28,0,0,1-.33,4.57c-.07.38-.11.76-.2,1.13l-.11.56a1.43,1.43,0,0,0-.07.48c.09.7.27,1.46.44,2.19.7,2.94,1.47,5.87,2.25,8.8,3.15,11.71,6.33,23.41,9.68,35.06l2.52,8.74c.43,1.45.86,2.9,1.33,4.34.23.71.46,1.44.73,2.1s.64,1.33,1,2c2.85,5.33,5.94,10.55,8.93,15.83,0,0,15.21,25.56,18.34,31.46.15.27.08.45-.2.08-2.72-3.54-12.64-20.71-18.81-31.15-3.1-5.22-6.15-10.46-9.07-15.79-.37-.66-.7-1.37-1-2.06s-.53-1.46-.78-2.19c-.47-1.44-.91-2.89-1.35-4.35-.87-2.91-1.73-5.82-2.56-8.73-3.26-11.69-6.48-23.39-9.44-35.15-.73-2.95-1.46-5.89-2.12-8.86-.15-.75-.32-1.47-.41-2.28a1.92,1.92,0,0,1,.08-.64l.12-.55c.09-.36.14-.74.21-1.11a29.26,29.26,0,0,0,.41-4.48A32.11,32.11,0,0,0,640.62,261.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.42,239.9,594,265s42.33-1.47,52.37-2.66c0,0-12.19-46.08-23.6-57.32-5.7-5.62-12-4.87-15.9-.56-1,1.09-12.43,17.87-13.42,24.11C592.6,234.07,596.42,239.9,596.42,239.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.17,201.47a.31.31,0,0,1-.19.06.33.33,0,0,1-.31-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.05,210.12a.35.35,0,0,1-.35.35.35.35,0,1,1,0-.7A.35.35,0,0,1,605.05,210.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,210.12a.35.35,0,1,1-.35-.35A.35.35,0,0,1,611.19,210.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,210.12a.35.35,0,1,1-.35-.35A.35.35,0,0,1,617.33,210.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,210.12a.35.35,0,1,1-.35-.35A.35.35,0,0,1,623.47,210.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,205.65a.35.35,0,1,1-.35-.35A.36.36,0,0,1,608.12,205.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,205.65a.35.35,0,1,1-.35-.35A.36.36,0,0,1,614.26,205.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,205.65a.35.35,0,1,1-.35-.35A.36.36,0,0,1,620.4,205.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.91,219.06a.35.35,0,0,1-.35.35.34.34,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,598.91,219.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.05,219.06a.35.35,0,0,1-.35.35.34.34,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,605.05,219.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,219.06a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,219.06a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,219.06a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.61,219.06a.34.34,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,629.61,219.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,214.6a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.34.34,0,0,1,.35-.35A.35.35,0,0,1,602,214.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,214.6a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,214.6a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,214.6a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.54,214.6a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.34.34,0,0,1,626.54,214.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.91,228a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.34.34,0,0,1,.35-.35A.35.35,0,0,1,598.91,228Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.05,228a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.34.34,0,0,1,.35-.35A.35.35,0,0,1,605.05,228Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,228a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,228a.35.35,0,1,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,228a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.61,228a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.34.34,0,0,1,629.61,228Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.37,228.35a.34.34,0,0,1-.32-.34.39.39,0,0,1,.09-.24C635.22,228,635.29,228.16,635.37,228.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.84,223.54a.36.36,0,0,1-.35.36.34.34,0,0,1-.32-.21h0c.08-.16.15-.31.22-.47l.1,0A.35.35,0,0,1,595.84,223.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,223.54a.35.35,0,0,1-.35.35.34.34,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,602,223.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,223.54a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,223.54a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,223.54a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.54,223.54a.34.34,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,626.54,223.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.68,223.54a.34.34,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,632.68,223.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.91,237a.35.35,0,0,1-.35.35.35.35,0,0,1,0-.7A.35.35,0,0,1,598.91,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.05,237a.35.35,0,0,1-.35.35.35.35,0,0,1,0-.7A.35.35,0,0,1,605.05,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,237a.35.35,0,1,1-.35-.35A.35.35,0,0,1,611.19,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,237a.35.35,0,1,1-.35-.35A.35.35,0,0,1,617.33,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,237a.35.35,0,1,1-.35-.35A.35.35,0,0,1,623.47,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.61,237a.35.35,0,0,1-.35.35.35.35,0,0,1,0-.7A.35.35,0,0,1,629.61,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.75,237a.35.35,0,0,1-.35.35.35.35,0,0,1,0-.7A.35.35,0,0,1,635.75,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.84,232.49a.35.35,0,0,1-.35.35.36.36,0,0,1,0-.71A.36.36,0,0,1,595.84,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,232.49a.35.35,0,0,1-.35.35.36.36,0,0,1,0-.71A.36.36,0,0,1,602,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,232.49a.35.35,0,1,1-.35-.36A.35.35,0,0,1,608.12,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,232.49a.35.35,0,1,1-.35-.36A.35.35,0,0,1,614.26,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,232.49a.35.35,0,1,1-.35-.36A.35.35,0,0,1,620.4,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.54,232.49a.35.35,0,0,1-.35.35.36.36,0,0,1,0-.71A.35.35,0,0,1,626.54,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.68,232.49a.35.35,0,0,1-.35.35.36.36,0,0,1,0-.71A.35.35,0,0,1,632.68,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.91,245.89a.36.36,0,0,1-.35.36.36.36,0,0,1,0-.71A.35.35,0,0,1,598.91,245.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.05,245.89a.36.36,0,0,1-.35.36.36.36,0,0,1,0-.71A.35.35,0,0,1,605.05,245.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,245.89a.35.35,0,1,1-.35-.35A.36.36,0,0,1,611.19,245.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,245.89a.35.35,0,1,1-.35-.35A.36.36,0,0,1,617.33,245.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,245.89a.35.35,0,1,1-.35-.35A.36.36,0,0,1,623.47,245.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.61,245.89a.35.35,0,0,1-.35.36.36.36,0,0,1,0-.71A.35.35,0,0,1,629.61,245.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.75,245.89a.35.35,0,0,1-.35.36.36.36,0,0,1,0-.71A.35.35,0,0,1,635.75,245.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.62,246.23a.11.11,0,0,1-.08,0,.35.35,0,0,1-.35-.35.34.34,0,0,1,.22-.32s0,0,0,0C641.49,245.8,641.56,246,641.62,246.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,241.43a.35.35,0,0,1-.35.35.35.35,0,1,1,0-.7A.35.35,0,0,1,602,241.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,241.43a.35.35,0,1,1-.35-.35A.35.35,0,0,1,608.12,241.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,241.43a.35.35,0,1,1-.35-.35A.35.35,0,0,1,614.26,241.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,241.43a.35.35,0,1,1-.35-.35A.35.35,0,0,1,620.4,241.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.54,241.43a.35.35,0,0,1-.35.35.35.35,0,1,1,0-.7A.35.35,0,0,1,626.54,241.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.68,241.43a.35.35,0,0,1-.35.35.35.35,0,1,1,0-.7A.35.35,0,0,1,632.68,241.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.82,241.43a.35.35,0,0,1-.35.35.35.35,0,1,1,0-.7A.35.35,0,0,1,638.82,241.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598.56,
    cy: 254.84,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.7,
    cy: 254.84,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,254.84a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,254.84a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,254.84a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.61,254.84a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.34.34,0,0,1,629.61,254.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635.4,
    cy: 254.84,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.89,254.84a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.34.34,0,0,1,641.89,254.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.84,250.38a.35.35,0,0,1-.35.35l-.11,0,.07-.68h0A.36.36,0,0,1,595.84,250.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,250.37a.35.35,0,0,1-.35.35.34.34,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,602,250.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,250.37a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613.91,
    cy: 250.37,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.05,
    cy: 250.37,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.54,250.37a.34.34,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,626.54,250.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.68,250.37a.34.34,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,632.68,250.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.82,250.37a.34.34,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.35.35,0,0,1,638.82,250.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598.56,
    cy: 263.78,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.7,
    cy: 263.78,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,263.78a.35.35,0,0,1-.7,0,.35.35,0,0,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,263.78a.34.34,0,0,1-.16.3h-.35a.34.34,0,0,1-.19-.31.35.35,0,0,1,.35-.35A.35.35,0,0,1,617.33,263.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,263.78h0l-.69,0a.07.07,0,0,1,0-.05.35.35,0,0,1,.35-.35A.35.35,0,0,1,623.47,263.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.46,263.5l-.43,0a.32.32,0,0,1,.23-.09A.27.27,0,0,1,629.46,263.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.84,259.32a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.34.34,0,0,1,.35-.35A.35.35,0,0,1,595.84,259.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,259.32a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.34.34,0,0,1,.35-.35A.35.35,0,0,1,602,259.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,259.32a.35.35,0,1,1-.7,0,.35.35,0,0,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613.91,
    cy: 259.32,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.05,
    cy: 259.32,
    r: 0.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.54,259.32a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.34.34,0,0,1,626.54,259.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.68,259.32a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.34.34,0,0,1,632.68,259.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.82,259.32a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.34.34,0,0,1,638.82,259.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645,259.32a.36.36,0,0,1-.71,0,.36.36,0,0,1,.71,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.85,203.45c-.28.83-4.85,6-8.73,5.46-1.26-.18-.6-7.12-.6-7.12l-.07-.52-1-7.33,8.92-4.64,1.29-.61s.13,2,.26,4.54c0,.12,0,.24,0,.36l0,.41c0,.38.05.76.06,1.14s0,.58,0,.89l0,.91A47.8,47.8,0,0,1,617.85,203.45Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618,193.23a14.84,14.84,0,0,1-9.52,8l-1-7.33,8.92-4.64,1.29-.61S617.84,190.71,618,193.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.77,181.58c-2.35,12.75,5,15.59,7.78,16.09,2.49.46,11.05,1.69,14.7-10.75s-1.54-17.56-7.19-18.9S601.11,168.82,598.77,181.58Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601,179.58c.31,0,.59-.06.89-.09a1.51,1.51,0,0,0,.9-.26.48.48,0,0,0,.06-.56,1.14,1.14,0,0,0-1.09-.39,1.72,1.72,0,0,0-1.12.47A.5.5,0,0,0,601,179.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.59,180.84c-.29-.07-.56-.19-.85-.28a1.5,1.5,0,0,1-.81-.46.47.47,0,0,1,.07-.56,1.18,1.18,0,0,1,1.15-.14,1.68,1.68,0,0,1,1,.71A.5.5,0,0,1,609.59,180.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.38,183.52s.06,0,0,.08c-.14.87-.17,1.9.59,2.29,0,0,0,.06,0,.05C607.05,185.68,607.1,184.32,607.38,183.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,182.71c1.42.08,1.15,2.92-.17,2.84S607.09,182.64,608.28,182.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.82,182.91c.24.19.45.49.75.55s.63-.2.88-.47c0,0,0,0,0,0,0,.55-.31,1.08-.9,1.11s-.87-.5-1-1.06C608.63,183,608.73,182.84,608.82,182.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.52,182.72s-.07,0-.08.07c-.05.88-.25,1.88-1.07,2.1,0,0,0,.06,0,.05C602.35,184.89,602.61,183.56,602.52,182.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.81,181.73c-1.4-.23-1.76,2.59-.46,2.81S603,181.93,601.81,181.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.2,181.84c-.24.12-.5.37-.77.35s-.5-.36-.66-.67c0,0,0,0,0,0-.08.54,0,1.13.53,1.3s.87-.27,1.07-.79C601.36,182,601.3,181.79,601.2,181.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.9,190.35c-.22.19-.44.47-.77.48a2.37,2.37,0,0,1-.93-.27s-.06,0,0,0a1.19,1.19,0,0,0,1.09.54,1,1,0,0,0,.74-.75S606.93,190.32,606.9,190.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.58,186.78a18.32,18.32,0,0,0-.39,1.91c0,.06.14.1.35.14h0a3,3,0,0,0,3-.79.07.07,0,0,0-.08-.1,4.46,4.46,0,0,1-2.77.48c0-.17.63-2.19.53-2.21a5.46,5.46,0,0,0-1.44.17c.6-2.71,1.62-5.3,2.18-8a.09.09,0,0,0-.16-.06,45,45,0,0,0-2.71,8.53C602,187.18,603.32,186.86,603.58,186.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.64,188.36a3.56,3.56,0,0,0,1.16,1.41,1.63,1.63,0,0,0,1,.28c.74,0,.9-.66.9-1.24a3.92,3.92,0,0,0-.12-.91A4.75,4.75,0,0,1,603.64,188.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.8,189.77a1.63,1.63,0,0,0,1,.28c.74,0,.9-.66.9-1.24A1.69,1.69,0,0,0,604.8,189.77Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.72,167.59s10.5-4.71,16.4,1.45,0,15.19,0,15.19,2.58-11.43-3-14.63S605.72,167.59,605.72,167.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.13,187a5.31,5.31,0,0,1-2.81-4.41,13.76,13.76,0,0,1-5.46-4.71c.08.27.63,2.2.94,3.17-8.08-1.8-10.38-8.1-10.38-8.1a13.9,13.9,0,0,0-3.72,5s.11-5,2.79-8.24c3.28-4,13.91-4.73,18.64.77C626.22,176.48,621.13,187,621.13,187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.67,179.52a14.77,14.77,0,0,0,4.12,1.68s0,0,0,0a12.78,12.78,0,0,1-5.84-3.81,12.37,12.37,0,0,1-1.68-2.51,8.38,8.38,0,0,1-1-3.14.07.07,0,0,0-.13,0,9.82,9.82,0,0,0,.54,3.23,8.89,8.89,0,0,0,1.71,2.75,10.1,10.1,0,0,0,2.25,1.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.05,186.42s3.2-3.76,4.93-2.59-.94,6.82-3.17,7.42a2.2,2.2,0,0,1-2.81-1.46Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.17,185.43a0,0,0,0,1,0,.06,5.54,5.54,0,0,0-3.18,3.18,1.21,1.21,0,0,1,1.83-.16s0,.09-.05.08a1.34,1.34,0,0,0-1.52.33,6.44,6.44,0,0,0-.82,1.12c-.08.13-.32,0-.25-.11v0C619.35,188,621.09,185.43,623.17,185.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.38,212.25c.42,10.56-15.77,42.65-21,47.07-7.52,6.41-33.3,9.75-40.73,10.87-3.23.49-5-23.36-1.54-23.94,7.55-1.28,25.32-4.57,27.52-6s13.78-14.22,21.2-22.93C621.83,205.65,626.17,206.9,626.38,212.25Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.13,249.74c1.42-.7,1.06-1.45-1.69-2s-14.11-.52-13.79-4.49,16.35-3.8,20.85-2.49,11.33,5,11.33,5C567.7,246.33,560.25,248.49,554.13,249.74Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573,268.91c-9,1.6-20.2,3.77-29.6,0a5,5,0,0,1-2.53-2.09c-4.25-1.61-4.76-4.09-4.76-4.09-3.49-2.71-3.67-5.33-3.67-5.33s-5-1.94-4.28-5.14c.75-3.58,7.57-.15,12.47-.55,11.24-.93,27-5.4,30.17-6Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.12,259a70.85,70.85,0,0,1-9.88.25,72.61,72.61,0,0,1-10.66-1.92.09.09,0,0,0-.05.17,38.36,38.36,0,0,0,20.61,1.65C553.29,259.14,553.29,259,553.12,259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.67,265.72c-3.23,0-8.92,0-18.5-3.09a0,0,0,0,0,0,.06,34.33,34.33,0,0,0,18.52,3.18C554.87,265.86,554.89,265.72,554.67,265.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.44,269.34c-5.51-.17-9-1-14.52-2.52,0,0,0,0,0,.05,6.14,2.43,8.64,2.61,14.56,2.66C555.66,269.53,555.65,269.34,555.44,269.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.87,213.66c9.88-10.67,15.58-6.26,12.22,6.29a223.75,223.75,0,0,1-8.24,24l-19.66-12.94S607.55,220.49,613.87,213.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,210.12a.35.35,0,1,1-.35-.35A.35.35,0,0,1,623.47,210.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,219.06a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,219.06a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,219.06a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,214.6a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,214.6a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.54,214.6a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.35.35,0,0,1,.35-.35A.34.34,0,0,1,626.54,214.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.05,228a.35.35,0,0,1-.35.35.35.35,0,0,1-.35-.35.34.34,0,0,1,.35-.35A.35.35,0,0,1,605.05,228Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,228a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,228a.35.35,0,1,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.47,228a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,223.54a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,223.54a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,223.54a.35.35,0,0,1-.7,0,.35.35,0,1,1,.7,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19,237a.35.35,0,1,1-.35-.35A.35.35,0,0,1,611.19,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.33,237a.35.35,0,1,1-.35-.35A.35.35,0,0,1,617.33,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,232.49a.35.35,0,0,1-.35.35.36.36,0,0,1,0-.71A.36.36,0,0,1,602,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.12,232.49a.35.35,0,1,1-.35-.36A.35.35,0,0,1,608.12,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,232.49a.35.35,0,1,1-.35-.36A.35.35,0,0,1,614.26,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,232.49a.35.35,0,1,1-.35-.36A.35.35,0,0,1,620.4,232.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,241.43a.34.34,0,0,1,0,.17l-.58-.38a.35.35,0,0,1,.28-.14A.35.35,0,0,1,614.26,241.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.88,214.84c-1.32,1.39-2.68,2.74-4,4.1.39-.72.74-1.46,1.07-2.22a0,0,0,1,0,0,0c-.31.58-.65,1.14-1,1.72l-.45.83a1.62,1.62,0,0,1-.1.18c-1,1.06-2.1,2.12-3.12,3.21-1.22,1.3-2.41,2.63-3.6,4s-2.45,3-3.73,4.33c-.11.11,1.73,1.16,1.9,1.28s.33,0,.14-.12-1.6-1.23-1.62-1.25c1.2-1.34,2.54-2.55,3.77-3.85s2.47-2.58,3.67-3.9c2.44-2.67,4.73-5.49,7.15-8.18A0,0,0,0,0,612.88,214.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.42,227c-.4.58-.83,1.15-1.19,1.75-.15.25-.3.5-.46.75q1.17-3.31,2.32-6.64s0-.05,0,0c-1.45,3.56-2.91,7.12-4.29,10.71A110.47,110.47,0,0,0,618,243.9a11.91,11.91,0,0,0-1.88-.93,9.64,9.64,0,0,0,2,1.34,112,112,0,0,0,4.2-10.79c.37-1,.71-2,1.07-3,.32-.59.68-1.14,1-1.71s.71-1.22,1.05-1.84C625.5,227,625.44,226.92,625.42,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618,240.44c-2.7-2-14.06-9.95-16.63-11.5-.18-.11-.29,0-.12.11a188.76,188.76,0,0,0,16.66,11.49C618,240.58,618.05,240.49,618,240.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.61,
    y: 156.4,
    width: 94.14,
    height: 94.14,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.75,198c13.1,9.66,30.84,16.89,35.66,14.48s14.46-24.85,14.48-30.41c0-2.41-16-5.36-17.84-3.54s-5,15.69-6,16.9c-.73.88-14.77-2.88-23.61-4.7C371.79,189.56,367.84,192.9,374.75,198Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.38,185.19c.8-2.32,4-14.43,4.07-17.65s-.39-12.49-2.85-12.8-2.54,2.42-2.54,2.42-.81-3.89-3.32-4-2.49,4.16-2.49,4.16-1.13-3.93-3.63-3.83-1.77,4.36-1.77,4.36-.87-3.64-2.9-2.69c-2.44,1.14-.09,7.67-.43,11.22-.08.8-2.77,16.2-2.77,16.2Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.79,157.52c1.72,4.8,1.64,7.2.54,12.11,0,.09.12.15.15.05,1.51-4.7,2-7.7-.46-12.26C411.9,157.2,411.71,157.29,411.79,157.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.11,157c1.35,5.15,1.28,7.76.51,13,0,.07.11.1.13,0,1.18-5.06,1.65-8.06-.37-13C417.29,156.72,417.05,156.74,417.11,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,157.43c.95,5.07,1,7.93-.4,12.91a.1.1,0,0,0,.18.06,17.15,17.15,0,0,0,.38-13C423.07,157.11,423,157.11,423,157.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,185.73a62.15,62.15,0,0,1-4.11-8.26c-.89-2.74-.42-14.16,2.05-14.19,3.19-.06,4.22,6.59,4.3,9.91,0,0,7.38-.12,9.15,4.49S405,185.73,405,185.73Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.82,163.55c2.95,2,2.77,6.42,3.09,9.63a.3.3,0,0,0,.41.26c3.1.15,7.42,1.27,9.16,4.05a.07.07,0,0,0,.13-.07c-1.46-3.23-5.62-4.68-9-4.63-.27-3.3-.29-7.69-3.75-9.27C403.82,163.51,403.81,163.54,403.82,163.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.08,212.62l5.74-18.17s-14.27-3.91-23.19-4.69-12.22,2.35-1.73,10.19A188.56,188.56,0,0,0,395.08,212.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.19,194.33c-1,2.48-2,5-2.86,7.53-.44,1.24-.9,2.49-1.31,3.74s-.77,2.63-1.2,3.92c0,.1.1.16.14.06.46-1.23,1-2.44,1.47-3.67s.92-2.57,1.38-3.86q1.33-3.8,2.49-7.67C397.33,194.31,397.22,194.26,397.19,194.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.58,250.55h54.18c.23-2.07-8.07-46.09-17.82-60.25-1.11-1.6-10.58-2.77-14.06,1.22C345.46,212.68,341.14,250,341.58,250.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.18,198.38c-2.92,1.05-8.59-2.95-11.05-6.43-.16-.24-.08-3-.13-6.29,0-2-.13-4.26-.36-6.3L377.79,181a32.39,32.39,0,0,0-.35,8,5.06,5.06,0,0,0,.18.83s0,.09,0,.14C378.1,191.52,379,197.37,376.18,198.38Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.62,189.83s0,0,0,0A15.6,15.6,0,0,1,365,184.28c0-1.62-.14-3.33-.32-4.92L377.79,181a32.39,32.39,0,0,0-.35,8A4.47,4.47,0,0,0,377.62,189.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.22,165.32c-.93,4.68,2.76,17.58,6.29,20.18,5.1,3.78,12.81,3.43,15.86-2.56,3-5.81-2.16-22.52-6-24.82C371.63,154.72,362.61,158.41,361.22,165.32Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,172.26s-.06.06-.05.1c.27.86.44,1.89-.27,2.4a0,0,0,0,0,0,.05C373.43,174.4,373.19,173,372.8,172.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.76,171.57c-1.42.29-.74,3.12.58,2.86S373,171.33,371.76,171.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.1,170.69s.08,0,.09.07c.18.88.54,1.86,1.4,2,0,0,0,.05,0,.06C378.59,172.87,378.13,171.56,378.1,170.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.66,169.59c1.39-.45,2.18,2.36.9,2.77S377.5,170,378.66,169.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.33,170.54a9.65,9.65,0,0,0,1-.65c.38-.25.71-.41.9-.86a.62.62,0,0,0-.27-.7,1.54,1.54,0,0,0-1.54.21,2.25,2.25,0,0,0-1,1.24A.65.65,0,0,0,370.33,170.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.42,167.9c-.41,0-.79,0-1.2,0a2,2,0,0,1-1.22-.26.62.62,0,0,1-.14-.74,1.54,1.54,0,0,1,1.42-.63,2.23,2.23,0,0,1,1.53.51A.66.66,0,0,1,379.42,167.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.41,180.3c.26.16.54.39.86.34a2.27,2.27,0,0,0,.89-.45s.07,0,0,0a1.19,1.19,0,0,1-1,.74,1,1,0,0,1-.87-.61C374.31,180.31,374.37,180.28,374.41,180.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.7,177.45a3.05,3.05,0,0,0,2.32.85,3.82,3.82,0,0,0,1.09-.21l.2-.07.18-.08a.21.21,0,0,0,.13-.23h0l0-.09h0l0-.07c-.15-.68-.46-1.7-.46-1.7.28.07,1.67.33,1.57,0a46.8,46.8,0,0,0-3.33-8.77c-.05-.09-.19,0-.16.06.73,2.81,2,5.46,2.74,8.27a5.37,5.37,0,0,0-1.52-.09c-.09.05.64,1.95.68,2.26v0a4.23,4.23,0,0,1-3.32-.22C374.69,177.32,374.63,177.39,374.7,177.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,178a3.71,3.71,0,0,1-1.22,1.39,1.66,1.66,0,0,1-1,.25c-.74,0-.88-.7-.86-1.28a4.14,4.14,0,0,1,.15-.91A4.71,4.71,0,0,0,377.63,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.41,179.35a1.66,1.66,0,0,1-1,.25c-.74,0-.88-.7-.86-1.28A1.69,1.69,0,0,1,376.41,179.35Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,176.61c3.66-.39,4.77-5,3.31-8.35,0,0,9.83-.44,8.91-8.23a7.68,7.68,0,0,0,6.86,2.34l1.58,2.65c.94-.46,1.49-3.45-1.32-5.21a9.32,9.32,0,0,0-4.1-5.61,5.32,5.32,0,0,0-5.78.22,8.09,8.09,0,0,0-6.05-.4A6.9,6.9,0,0,0,360,158.6s-4.59,1.75-4.8,5.28a7.16,7.16,0,0,0,1.95,5.48s-1,1.54.16,4.31C358,175.46,359.82,176.73,360.92,176.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.81,159.38a9.43,9.43,0,0,1,.35,1.88,7.39,7.39,0,0,1,0,1.88,4.9,4.9,0,0,1-1.73,3.17,8,8,0,0,1-3.38,1.52c-.63.09-1.25.23-1.88.29s-1.28.08-1.92.14c.64,0,1.28.05,1.93.08s1.29-.11,1.94-.17a7.78,7.78,0,0,0,3.6-1.52,5.12,5.12,0,0,0,1.78-3.47A7.82,7.82,0,0,0,372.81,159.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.55,163a10.06,10.06,0,0,1-3.19-1,5.74,5.74,0,0,1-1.33-1,7.2,7.2,0,0,1-1.07-1.31,4.27,4.27,0,0,0,.81,1.55,4.53,4.53,0,0,0,1.37,1.13,5.65,5.65,0,0,0,1.67.59A5.1,5.1,0,0,0,378.55,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.6,177.89a4.13,4.13,0,1,1,3.12-5.73h0a4.14,4.14,0,0,1-2.14,5.44A3.92,3.92,0,0,1,372.6,177.89Zm-1.24-7.61a3.83,3.83,0,0,0-.86.25,3.6,3.6,0,1,0,.86-.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7,175.24c-1.56.25-3.23-1.12-3.83-3.19a4.92,4.92,0,0,1,.05-3,2.57,2.57,0,0,1,4.23-1.21,4.91,4.91,0,0,1,1.64,2.54c.62,2.19-.19,4.35-1.82,4.82Zm-1.65-7.52-.2,0a2.17,2.17,0,0,0-1.41,1.46,4.43,4.43,0,0,0,0,2.68c.55,1.9,2.07,3.13,3.41,2.75s2-2.24,1.45-4.14a4.34,4.34,0,0,0-1.45-2.25A2.23,2.23,0,0,0,380.05,167.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.72,172.66l-.46-.31c.46-.68,1.66-1.76,2.93-1l-.29.48C376.77,171.14,375.76,172.6,375.72,172.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.31,178.75l-.54-.11c.05-.26.53-2.49,1.66-3s8.37-1.86,8.68-1.92l.1.54c-2.1.39-7.73,1.5-8.55,1.88S358.43,178.13,358.31,178.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.09,175.74s-3.47-3.88-5.27-2.59,1.17,7.16,3.52,7.73a2.31,2.31,0,0,0,2.93-1.6Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.71,174.81s0,.05,0,.06a5.82,5.82,0,0,1,3.43,3.27,1.28,1.28,0,0,0-1.94-.12.05.05,0,0,0,.06.08,1.42,1.42,0,0,1,1.61.31,6.81,6.81,0,0,1,.89,1.17c.09.13.34,0,.27-.13l0,0C364.81,177.39,362.9,174.76,360.71,174.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.62,189.68l-2.8,7.74L365,188.18l-2.55,3.18s9.8,14.9,9.83,14.21l2.88-6.66,4.68,4.38-.8-11.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.79,197.63c-.19-1.88-.34-3.78-.62-5.65,0-.06-.11-.09-.13,0-.31,1.83.48,9,.54,10.74l0,0c-.2-.19-4.34-3.84-4.37-3.78-.64,1.06-2.76,5.91-2.9,6.35-1.55-2.37-7.47-11-9.28-13.18a.07.07,0,0,0-.11.07c1.38,2.51,9.23,14.08,9.34,14a73.41,73.41,0,0,0,3-7c.7.8,4.9,4.94,4.9,4.66A58.24,58.24,0,0,0,379.79,197.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,192.94c-7.42,3.28-32.14,26-33.95,31.7-2.82,8.89-1,26.05-.11,25.9,2.34-.39,23.27-4.94,22.21-7.14-1-2-3.91-9.7-4.05-13-.07-1.55,15.82-26.52,19.07-31.39C368.37,192.77,367.46,190.09,361,192.94Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.36,241a3.35,3.35,0,0,1,3.43,1.89s1.25-2.77,3.78-2.76c1.3,0,2.43,2.09,2.43,2.09a3.76,3.76,0,0,1,3.34-2c1.79.12,2.66,2.18,2.66,2.18s2-1.59,3.81-.89c3.62,1.43,4.22,16.82-1.35,19.42-2.6,1.21-2.54-2.56-2.54-2.56s-1.39,5.4-4.56,5.6-2.8-4.68-2.8-4.68-1.39,5.22-4.7,5.1-2.23-4.95-2.23-4.95-2.19,3.51-4.7,2.84c-4.14-1.1.56-8.38-.37-11.73H327S333.23,241.83,339.36,241Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.25,245.51c3.47.57,6.68-4.21,10.08-4.13,4.59.09,1.65,7.85-4.67,9.21h-5.4Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.18,242.71c0-.05.07-.07.08,0a26.74,26.74,0,0,1-.32,15.89c-.06.16-.35.13-.32-.06A54.42,54.42,0,0,0,355.18,242.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,242.17c0-.06.09-.07.11,0a25.09,25.09,0,0,1-1.43,17.31c-.1.18-.37.26-.28,0C349,255.75,349.65,247.11,349,242.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.3,259.77c2.42-5.31,2.89-10.87,2.56-16.64,0-.08.1-.08.12,0,.94,2.78.77,6.48.39,9.35a15.44,15.44,0,0,1-2.88,7.39C340.43,260,340.25,259.89,340.3,259.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82,246.83a.06.06,0,0,0,.09.09c2.62-2.26,10.3-8.83,12.95-3.79.09.17.26.25.21,0C342.24,240,339,238.06,329.82,246.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.77,239.85a4,4,0,0,0-2.94,3.35c0,.11.18.17.22.06a4.6,4.6,0,0,1,2.06-2.58c1.67-.86,3,.26,3.86,1.64a.13.13,0,0,0,.24-.1A3.11,3.11,0,0,0,345.77,239.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5,239.84a3.68,3.68,0,0,0-3.47,2.28c-.12.23.13.23.15.21,1-1,1.9-2.11,3.4-1.82a4.52,4.52,0,0,1,2.49,2c.06.08.17,0,.15-.09A3.11,3.11,0,0,0,352.5,239.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.06,242.67a2.68,2.68,0,0,0-4.93-.19s0,.07,0,0a3.35,3.35,0,0,1,4.86.22C360.11,242.84,360.1,242.78,360.06,242.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.29,241.16c-.05,0,.12.42.17.42,3.29-.05,3.52,6.25,4.14,9,0,0,.08,0,.08,0C361.86,248.38,361.25,240.25,357.29,241.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77,207.39,354,218.86s8.43-12.15,12.14-20.31,1.86-12.3-9-5A190.35,190.35,0,0,0,338.77,207.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.31,215.48c-2-1.79-4.05-3.52-6.14-5.21-1-.82-2.05-1.67-3.09-2.48s-2.22-1.6-3.3-2.44a.08.08,0,0,0-.1.12c1,.84,2,1.76,3,2.61s2.12,1.72,3.18,2.58c2.09,1.69,4.23,3.33,6.4,4.91C355.29,215.61,355.37,215.53,355.31,215.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.36,218.37c.23.14.46.28.68.43l-.1,0c.61-1.14,1.28-2.24,1.94-3.35s1.37-2.18,2.08-3.25,1.44-2.14,2.2-3.17,1.52-2.08,2.34-3.08c-.59,1.14-1.24,2.26-1.9,3.36s-1.36,2.19-2.06,3.27-1.43,2.14-2.17,3.2-1.5,2.09-2.31,3.1L354,219l-.06-.05C353.75,218.74,353.55,218.56,353.36,218.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.54,208.3a8.09,8.09,0,0,1-3.11,2.36,7.61,7.61,0,0,1,1.41-1.37A8,8,0,0,1,362.54,208.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.82,
    y: 156.4,
    width: 94.14,
    height: 94.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18,253.7l.22.11,0-.05h0l-.23-.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.88,164.07c-2.1-3.51-6.54-5.1-11.16-5.09s-10.36,1.15-12.24,8.15c-1.52,5.68-.75,11.66-2,18.08s-11.94,20.64-1.23,30.59c9.62,8.94,33.07,6.84,36.51-7.16,2.72-11.09-9.17-24.08-9.78-28.8S268.18,167.92,265.88,164.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.65,170.77a24.35,24.35,0,0,0,.11,9.84,9.16,9.16,0,0,0,1,2.39c.41.75.87,1.47,1.32,2.18.92,1.42,1.83,2.83,2.66,4.27a33,33,0,0,1,3.8,9.07,24.83,24.83,0,0,1,.32,9.68,21.45,21.45,0,0,0,.79-4.85,22.91,22.91,0,0,0-.38-4.95,29.35,29.35,0,0,0-3.66-9.36c-.86-1.47-1.8-2.89-2.73-4.29a16.82,16.82,0,0,1-2.34-4.31,19.68,19.68,0,0,1-.81-4.78A38,38,0,0,1,266.65,170.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85,172c-.55,3.28-1,6.59-1.7,9.82a39.58,39.58,0,0,1-1.37,4.75c-.56,1.52-1.36,3-2.08,4.52s-1.41,3.06-2,4.64a27.54,27.54,0,0,0-1.3,4.89,17.51,17.51,0,0,0,0,5.06,12.27,12.27,0,0,0,2.05,4.68,13.08,13.08,0,0,1-1.57-4.73,16.71,16.71,0,0,1,.26-4.89,40.7,40.7,0,0,1,3.45-9.27,49.43,49.43,0,0,0,2.06-4.62,30.18,30.18,0,0,0,1.23-4.89A77.71,77.71,0,0,0,241.85,172Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.43,198.22c13.63,13,31.12,40.68,28.19,46.49-3.26,6.47-22.24-11.75-22.2-12.85,0-.83-7-17.76-12.26-30.07S262.06,195,265.43,198.22Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,231.88c-.62-1.81-10.12-24.13-12.86-31.19s-.46-9.34,6.93-3,23.83,27.69,27.78,39.17c3.8,11.07-1.95,11.24-9.69,6.33C277.12,239.14,271.3,231.88,271.3,231.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.63,221.71a4.67,4.67,0,0,0-1,1.46,4.67,4.67,0,0,0,1.46-1,4.74,4.74,0,0,0,1-1.46A4.91,4.91,0,0,0,281.63,221.71Zm-9.48-8.23a4.69,4.69,0,0,0-1.46-1,4.69,4.69,0,0,0,1,1.46,4.51,4.51,0,0,0,1.46,1A4.77,4.77,0,0,0,272.15,213.48Zm9,20a4.81,4.81,0,0,0-1.46-1,4.67,4.67,0,0,0,1,1.46,4.81,4.81,0,0,0,1.46,1A4.67,4.67,0,0,0,281.14,233.47Zm8.79,5.27a4.68,4.68,0,0,0-.3,1.75,4.73,4.73,0,0,0,.3,1.76,4.74,4.74,0,0,0,.31-1.76A4.5,4.5,0,0,0,289.93,238.74Zm-18.19-14a4.69,4.69,0,0,0-.31,1.75,4.74,4.74,0,0,0,.31,1.76,4.74,4.74,0,0,0,.31-1.76A4.69,4.69,0,0,0,271.74,224.71Zm-10.23-20a5,5,0,0,0-.31,1.76,4.9,4.9,0,0,0,.31,1.75,4.69,4.69,0,0,0,.31-1.75A4.74,4.74,0,0,0,261.51,204.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.72,250.52l-1.32-5.81-1.89-14.05s4.47-6.75,1.87-12.35c-1.31-2.84-12.79-21.54-17.63-25.05-4.53-3.29-11.12.23-13.57,2.81-9.44,9.94-13.9,27.57-17.29,54.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,204.69a5,5,0,0,0-.31,1.76,4.9,4.9,0,0,0,.31,1.75,4.69,4.69,0,0,0,.31-1.75A4.74,4.74,0,0,0,261.51,204.69Zm10.23,20a4.69,4.69,0,0,0-.31,1.75,4.74,4.74,0,0,0,.31,1.76,4.74,4.74,0,0,0,.31-1.76A4.69,4.69,0,0,0,271.74,224.71Zm-25.76.67a4.69,4.69,0,0,0-.31,1.75,5,5,0,0,0,.31,1.76,4.74,4.74,0,0,0,.31-1.76A4.69,4.69,0,0,0,246,225.38Zm13.46,20.3a4.74,4.74,0,0,0-.31,1.76,4.69,4.69,0,0,0,.31,1.75,4.69,4.69,0,0,0,.31-1.75A4.74,4.74,0,0,0,259.44,245.68Zm-20.25-42.89c-.19.31-.37.64-.55,1h0a4.18,4.18,0,0,0,.29,1.41,4.68,4.68,0,0,0,.3-1.75A4.44,4.44,0,0,0,239.19,202.79Zm11.37-2.69a4.9,4.9,0,0,0-1.75.31,4.69,4.69,0,0,0,1.75.31,4.74,4.74,0,0,0,1.76-.31A4.74,4.74,0,0,0,250.56,200.1Zm-1.75,39.08a4.73,4.73,0,0,0-1.76.3,4.74,4.74,0,0,0,1.76.31,4.5,4.5,0,0,0,1.75-.31A4.68,4.68,0,0,0,248.81,239.18Zm-12.06-23.36a4.9,4.9,0,0,0-1.75.31,4.69,4.69,0,0,0,1.75.31,4.74,4.74,0,0,0,1.76-.31A5,5,0,0,0,236.75,215.82Zm24.06,4.56a4.74,4.74,0,0,0-1.76.31,5,5,0,0,0,1.76.31,4.69,4.69,0,0,0,1.75-.31A4.69,4.69,0,0,0,260.81,220.38Zm10.62,19.1a4.9,4.9,0,0,0-1.75.31,4.69,4.69,0,0,0,1.75.31,4.74,4.74,0,0,0,1.76-.31A5,5,0,0,0,271.43,239.48ZM250.27,212.8a4.91,4.91,0,0,0-1.46-1,4.62,4.62,0,0,0,1,1.46,4.67,4.67,0,0,0,1.46,1A5,5,0,0,0,250.27,212.8Zm-14,26.78a4.81,4.81,0,0,0-1.46-1,4.67,4.67,0,0,0,1,1.46,4.62,4.62,0,0,0,1.46,1A4.74,4.74,0,0,0,236.23,239.58Zm35.92-26.1a4.69,4.69,0,0,0-1.46-1,4.69,4.69,0,0,0,1,1.46,4.51,4.51,0,0,0,1.46,1A4.77,4.77,0,0,0,272.15,213.48Zm-38.84,15.19a4.69,4.69,0,0,0-1,1.46,4.69,4.69,0,0,0,1.46-1,4.77,4.77,0,0,0,1-1.45A4.51,4.51,0,0,0,233.31,228.67Zm26.44,4.41a4.67,4.67,0,0,0-1,1.46,5.17,5.17,0,0,0,2.48-2.49A4.94,4.94,0,0,0,259.75,233.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,227.19a45.69,45.69,0,0,1,7.73.61c1.28.23,2.54.53,3.8.85.63.17,1.26.31,1.89.44a7.13,7.13,0,0,0,2,.21.06.06,0,0,1,0,.11,11.94,11.94,0,0,1-1.88.17,11.38,11.38,0,0,1-1.84-.2c-1.29-.22-2.58-.5-3.87-.74-2.61-.47-5.22-.94-7.85-1.2C254.89,227.43,254.9,227.19,255,227.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,230.52a49.75,49.75,0,0,1,6.29-1.06c1.06-.1,2.12-.13,3.18-.13q.76,0,1.53,0c.56,0,1.12.13,1.68.14a.06.06,0,0,1,0,.11c-.53,0-1.05.11-1.58.16l-1.58.12c-1.06.09-2.11.19-3.17.27-2.12.15-4.23.32-6.34.56C248.92,230.73,248.91,230.54,249,230.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.51,230.66a29,29,0,0,0,1.32-3.09,18,18,0,0,0,.88-3.19,9.81,9.81,0,0,0,.07-3.24,16.2,16.2,0,0,0-1-3.13,51.09,51.09,0,0,0-3-6c-1.1-1.95-2.26-3.87-3.44-5.78a53.06,53.06,0,0,1,3.93,5.48,42.37,42.37,0,0,1,3.17,6,16.87,16.87,0,0,1,.95,3.3,9.12,9.12,0,0,1-.17,3.46A19.11,19.11,0,0,1,273.51,230.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,208.14a10.57,10.57,0,0,1,.87,1.75,5.62,5.62,0,0,1,.45,1.9,8.92,8.92,0,0,0-.33-.91l-.35-.9C271.13,209.37,270.88,208.77,270.71,208.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.56,245c-3.6,3.75-11.73,3.31-32.32,4.12-2.84.11-9-19.78-6-20.05,3.83-.35,18.74-.87,19.83-.77C284.3,229.11,296,242.42,293.56,245Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.37,228.75s-8.66,0-13.22,1.35a30.57,30.57,0,0,0-12.38,7.82c-3.72,3.84-10.06,15.7-7,18.12,2.8,2.19,8.67-10.26,8.67-10.26s-8.08,11.71-4.22,13.73,9.85-12.82,9.85-12.82-8,12.21-3.72,13.66c3.26,1.1,9.44-12,9.44-12s-6.83,10.54-3.52,11.81c3.64,1.41,10.11-10.35,10.11-10.35,8.94,1.82,13.94-1,17.26-3.38C271.48,245.82,259.37,228.75,259.37,228.75Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,241.56c-1,1.34-2,2.69-2.89,4.11s-1.71,2.88-2.44,4.38a28.77,28.77,0,0,0-2.33,6.11,60.94,60.94,0,0,1,5.17-10.26c.87-1.42,1.67-2.89,2.55-4.31C238.09,241.55,238,241.53,238,241.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.21,244.63c-1.2,1.76-2.45,3.47-3.58,5.29s-2,3.63-3,5.52c-.07.14,0,.13.11,0,1.07-1.84,2.19-3.46,3.28-5.29s2.1-3.71,3.25-5.49C243.28,244.62,243.23,244.6,243.21,244.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.15,246.46A47.44,47.44,0,0,0,243.3,255c-.07.14.06.12.14,0,1.56-2.86,2.76-5.12,4.8-8.42C248.27,246.47,248.19,246.4,248.15,246.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,228.47l14.48,22.21s18.33-1.32,21.64-5.45c2.18-2.72-9.26-16.89-19.54-17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.93,238.74a4.68,4.68,0,0,0-.3,1.75,4.73,4.73,0,0,0,.3,1.76,4.74,4.74,0,0,0,.31-1.76A4.5,4.5,0,0,0,289.93,238.74Zm-18.5.74a4.9,4.9,0,0,0-1.75.31,4.69,4.69,0,0,0,1.75.31,4.74,4.74,0,0,0,1.76-.31A5,5,0,0,0,271.43,239.48Zm9.71-6a4.81,4.81,0,0,0-1.46-1,4.67,4.67,0,0,0,1,1.46,4.81,4.81,0,0,0,1.46,1A4.67,4.67,0,0,0,281.14,233.47Zm-20.85-.87.3.45a3.75,3.75,0,0,0,.62-1A4.4,4.4,0,0,0,260.29,232.6Zm20.83,14.11a4.51,4.51,0,0,0-1,1.46,4.94,4.94,0,0,0,1.46-1,4.67,4.67,0,0,0,1-1.46A4.81,4.81,0,0,0,281.12,246.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.68,233.22a17.59,17.59,0,0,0-11.51-5.05c-.06,0-.07.08,0,.09,4.41.55,10,3.77,11.49,5C285.67,233.32,285.72,233.26,285.68,233.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.37,248.16c-1.46-2.53-3.05-5-4.66-7.42s-3.2-4.89-4.86-7.29c-.94-1.36-1.87-2.73-2.86-4,0,0-.09,0-.06,0,1.45,2.52,3,5,4.62,7.43s3.2,4.89,4.84,7.31q1.38,2.06,2.85,4C277.29,248.3,277.41,248.23,277.37,248.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.61,228.21A25.66,25.66,0,0,1,261,228c1.13,0,2.27-.06,3.41-.06a68.66,68.66,0,0,1,11.12.35s-.22.19-.26.18c-1.92-.41-16.26.2-17.41.1l.09.26c0,.06-.06.12-.11.07s-.21-.25-.33-.38A.17.17,0,0,1,257.61,228.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.21,197.4c-15.74,16-27.67,34-26.46,38.48,2.26,8.34,13.51,9.24,15.05,7.28,6.27-7.93,12.37-22.83,18.95-39.43C255.63,188.89,247.39,192.13,242.21,197.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.31,228.67a4.69,4.69,0,0,0-1,1.46,4.69,4.69,0,0,0,1.46-1,4.77,4.77,0,0,0,1-1.45A4.51,4.51,0,0,0,233.31,228.67Zm-9-7a4.51,4.51,0,0,0-1.46-1,4.79,4.79,0,0,0,1,1.46,4.91,4.91,0,0,0,1.46,1A4.79,4.79,0,0,0,224.29,221.71Zm12.46-5.89a4.9,4.9,0,0,0-1.75.31,4.69,4.69,0,0,0,1.75.31,4.74,4.74,0,0,0,1.76-.31A5,5,0,0,0,236.75,215.82Zm13.81-15.72a4.9,4.9,0,0,0-1.75.31,4.69,4.69,0,0,0,1.75.31h.28l.18-.59ZM222.3,233.68a4.55,4.55,0,0,0-.31,1.76,4.69,4.69,0,0,0,.31,1.75,4.68,4.68,0,0,0,.3-1.75A4.73,4.73,0,0,0,222.3,233.68Zm16.63-32a4.55,4.55,0,0,0-.31,1.76,4.69,4.69,0,0,0,.31,1.75,4.68,4.68,0,0,0,.3-1.75A4.73,4.73,0,0,0,238.93,201.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.33,239.64c1.09-2,2.1-4.08,3.13-6.13s2-4.11,3-6.17c2-4.09,3.77-8.25,5.49-12.44,1-2.38,2-4.74,2.89-7.14,0-.07.16,0,.13.05-.85,2.77-1.78,5.5-2.81,8.2l.06-.09c.25-.39.49-.78.73-1.17.47-.77.91-1.57,1.33-2.37,0-.07.13,0,.1.05a25.44,25.44,0,0,1-1.62,3.16,13.38,13.38,0,0,1-.95,1.41l0,0c-.47,1.2-1,2.4-1.46,3.59-1.81,4.21-3.75,8.39-6,12.4-.63,1.13-1.26,2.26-1.92,3.37s-1.37,2.19-2,3.29C233.39,239.75,233.3,239.7,233.33,239.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.21,241.33c3.2-4.6,1.58-13.75-1.94-35.71-.49-3-23.56-3.28-23.2,0,.44,4.12,4.55,20.41,5.62,22.8C213.93,240.13,226,244.46,228.21,241.33Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.75,208.77c-.86-2.52-3.89-14.55-4-18s.45-13.56,3.12-13.88,2.75,2.63,2.75,2.63.9-4.22,3.61-4.3,2.69,4.53,2.69,4.53,1.24-4.27,3.95-4.15,1.92,4.74,1.92,4.74.95-4,3.15-2.92c2.64,1.24.07,8.32.44,12.17.08.88,3,17.6,3,17.6Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.89,179.9c-1.88,5.21-1.8,7.82-.62,13.14,0,.1-.13.16-.16.06-1.63-5.11-2.2-8.37.53-13.31C217.78,179.55,218,179.65,217.89,179.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.12,179.29c-1.48,5.59-1.41,8.42-.59,14.08,0,.08-.12.11-.14,0-1.27-5.49-1.77-8.75.44-14.14C211.93,179,212.19,179,212.12,179.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.71,179.77c-1,5.51-1.1,8.61.4,14a.1.1,0,0,1-.19.07,18.62,18.62,0,0,1-.38-14.1C205.65,179.42,205.78,179.42,205.71,179.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.18,210.54s3.52-6,4.49-8.95.49-15.37-2.19-15.42c-3.47-.06-4.6,7.15-4.7,10.75,0,0-8-.16-9.94,4.84S225.18,210.54,225.18,210.54Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.52,186.47c-3.2,2.22-3,6.95-3.37,10.44a.32.32,0,0,1-.45.28c-3.36.16-8.06,1.36-9.95,4.37a.08.08,0,0,1-.15-.07c1.59-3.51,6.11-5.06,9.8-5,.31-3.59.34-8.35,4.1-10.05C226.52,186.43,226.54,186.45,226.52,186.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7,213.06l26.74,7.58s5.34,17.53,1.95,21.93c-3.63,4.7-20.47-2.58-23.82-12.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,218.64a4.67,4.67,0,0,0-1,1.46,4.79,4.79,0,0,0,1.46-1,4.91,4.91,0,0,0,1-1.46A4.62,4.62,0,0,0,208,218.64Zm16.29,3.07a4.51,4.51,0,0,0-1.46-1,4.79,4.79,0,0,0,1,1.46,4.91,4.91,0,0,0,1.46,1A4.79,4.79,0,0,0,224.29,221.71Zm-9.95,6.53a4.73,4.73,0,0,0-1.76.3,4.74,4.74,0,0,0,1.76.31,4.5,4.5,0,0,0,1.75-.31A4.68,4.68,0,0,0,214.34,228.24Zm8,5.44a4.55,4.55,0,0,0-.31,1.76,4.69,4.69,0,0,0,.31,1.75,4.68,4.68,0,0,0,.3-1.75A4.73,4.73,0,0,0,222.3,233.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.57,226.73c-3-.68-5.93-1.52-8.88-2.36s-5.89-1.68-8.82-2.6c-1.65-.52-3.31-1-4.94-1.6,0,0,0-.09,0-.08,3,.67,5.93,1.5,8.88,2.32s5.89,1.68,8.83,2.56c1.66.5,3.31,1,4.94,1.61C228.68,226.6,228.66,226.75,228.57,226.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.49,220.35c.42.05.83.13,1.25.21a.17.17,0,0,1,.12.14c.46,1.55.79,3.16,1.11,4.74s.6,3.14.86,4.72q.21,1.28.36,2.55a9,9,0,0,1,.93,3.31c0,.06-.1.07-.1,0a11.34,11.34,0,0,0-.79-3,21.22,21.22,0,0,1-.17,6.26s0,0,0,0c.53-3.09-.25-6.31-.76-9.35-.25-1.52-.54-3-.84-4.55s-.65-3-.92-4.53a10.69,10.69,0,0,1-1.06-.43C228.41,220.43,228.44,220.35,228.49,220.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.69,194.83c.14.89,3.87,6.82,7.86,6.93,1.29,0,1.78-7,1.78-7l.16-.51,2.17-7.19-8.19-6.14-1.18-.82s-.47,2-1,4.51c0,.11-.05.23-.08.35s-.07.28-.1.41c-.08.37-.17.75-.25,1.14s-.12.57-.18.87-.11.61-.17.92A48.3,48.3,0,0,0,250.69,194.83Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.27,184.57a15.08,15.08,0,0,0,8.22,9.64l2.17-7.19-8.19-6.14-1.18-.82S252.82,182.06,252.27,184.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.7,174.19c2,13-5.58,15.7-8.39,16.13-2.55.39-11.28,1.39-14.63-11.36s2.09-17.81,7.87-19S270.69,161.16,272.7,174.19Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.72,171.62a6.88,6.88,0,0,1-.9-.1,1.52,1.52,0,0,1-.91-.27.48.48,0,0,1-.05-.57,1.14,1.14,0,0,1,1.11-.39,1.71,1.71,0,0,1,1.13.5A.5.5,0,0,1,268.72,171.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.38,171.38a8,8,0,0,0,.87-.26,1.46,1.46,0,0,0,.84-.44.47.47,0,0,0,0-.57,1.15,1.15,0,0,0-1.16-.17,1.69,1.69,0,0,0-1,.69A.5.5,0,0,0,259.38,171.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.71,175.8s-.07,0-.06.09c.12.89.11,1.93-.66,2.31,0,0,0,.06,0,.05C262,178,262,176.63,261.71,175.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.81,175c-1.45,0-1.25,2.93.09,2.89S262,174.92,260.81,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,175.15c-.24.18-.47.48-.77.53s-.63-.22-.88-.5c0,0-.05,0-.05,0,0,.55.28,1.11.88,1.15s.9-.48,1-1C260.45,175.22,260.35,175.07,260.25,175.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.32,175.06s.07,0,.08.08c0,.89.23,1.92,1.07,2.15,0,0,0,.05,0,.05C267.46,177.28,267.22,175.92,267.32,175.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.05,174.07c1.43-.22,1.76,2.66.44,2.86S266.85,174.25,268.05,174.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,174.19c.25.12.5.38.78.36s.51-.35.68-.67c0,0,0,0,.05,0,.08.55,0,1.14-.56,1.31s-.88-.28-1.07-.81C268.51,174.3,268.57,174.14,268.67,174.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.88,182.75c.22.2.44.49.76.51a2.28,2.28,0,0,0,1-.25,0,0,0,0,1,0,.05,1.23,1.23,0,0,1-1.13.51,1,1,0,0,1-.72-.78S262.84,182.72,262.88,182.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.36,179.22s.29,1.32.34,1.95c0,.06-.14.1-.36.13h0a3,3,0,0,1-3-.89c-.05-.06,0-.13.09-.09a4.55,4.55,0,0,0,2.79.56c0-.17-.57-2.24-.47-2.26a5.3,5.3,0,0,1,1.46.21c-.53-2.77-1.49-5.43-2-8.2a.09.09,0,0,1,.16-.06,46.1,46.1,0,0,1,2.5,8.75C268,179.67,266.62,179.3,266.36,179.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,181.07a3.64,3.64,0,0,1-1.28,1.28,1.64,1.64,0,0,1-1,.18c-.72-.1-.82-.74-.76-1.3a3.85,3.85,0,0,1,.21-.88A4.66,4.66,0,0,0,266.13,181.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.85,182.35a1.64,1.64,0,0,1-1,.18c-.72-.1-.82-.74-.76-1.3A1.65,1.65,0,0,1,264.85,182.35Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.27,162.42a5.68,5.68,0,0,1-.27,3.34c-1.48,2.83-4.92,2-6.15,3.05s-.84,3.25-1.88,4.28c-1.44,1.43-3.32.79-3.59,1.78s-1,4.13-2.31,4.49-6.38-20.91,10.18-19.67c0,0,2.31-.86,5.78,1.05s5.59,8.64,5.59,8.64a3.92,3.92,0,0,1-.92-.69c-.77-.73-1.06-1.4-1.63-1.88-.9-.75-1.41-.49-2.35-1.22A11,11,0,0,1,264.27,162.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.05,161.5a11,11,0,0,1,.4,2.55,4.71,4.71,0,0,1-.44,2.45,3.48,3.48,0,0,1-2,1.42c-.79.26-1.67.31-2.53.62a2.56,2.56,0,0,0-1.14.8,3.42,3.42,0,0,0-.53,1.25,4.61,4.61,0,0,1-1,2.27,2.85,2.85,0,0,1-2.25.85,6.23,6.23,0,0,0-2.58,0,6.19,6.19,0,0,1,2.56.15,3.08,3.08,0,0,0,2.49-.83,4.67,4.67,0,0,0,1.14-2.39,3,3,0,0,1,.48-1.11,2.27,2.27,0,0,1,1-.66c.77-.29,1.65-.36,2.5-.65a4.44,4.44,0,0,0,1.21-.61,2.69,2.69,0,0,0,.91-1,4.91,4.91,0,0,0,.36-2.61A11.33,11.33,0,0,0,264.05,161.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.34,162.26a8.81,8.81,0,0,0,.73,2.32,4.16,4.16,0,0,0,1.6,1.88,6.44,6.44,0,0,0,1.13.49,1.93,1.93,0,0,1,.87.63,6.89,6.89,0,0,0,.69,1,2.61,2.61,0,0,0,1,.65,3,3,0,0,1-.88-.78,6.38,6.38,0,0,1-.57-1,2.13,2.13,0,0,0-1-.82,7,7,0,0,1-1.07-.47,4.54,4.54,0,0,1-1.52-1.7A18.62,18.62,0,0,1,264.34,162.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.34,179.33s-3.15-3.92-4.94-2.77.76,7,3,7.63a2.24,2.24,0,0,0,2.9-1.4Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.17,178.21a0,0,0,0,0,0,.06,5.6,5.6,0,0,1,3.14,3.32,1.22,1.22,0,0,0-1.86-.21s0,.09.05.08a1.37,1.37,0,0,1,1.54.37,7.12,7.12,0,0,1,.8,1.17c.08.14.33.05.26-.11v0C252,180.9,250.29,178.26,248.17,178.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.21,253.7l.23.06h0Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.22,256h0l.68.16Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.9fdbfa112d7cefc6861849f548f7cffb.svg";
export { ForwardRef as ReactComponent };